import { gql } from 'apollo-angular';

export const DELETE_BILL_BY_ID = gql`
  mutation removeBill($id: Int!) {
    removeBill(id: $id)
  }
`;

export const CREATE_NEW_BILL = gql`
  mutation createBill($createBillInput: CreateBillInput!) {
    createBill(createBillInput: $createBillInput) {
      id
      billNo
      vendorId
      accountId
      billDate
      dueDate
      subTotal
      tax
      totalAmount
      balance
    }
  }
`;

export const UPDATE_BILL_BY_ID = gql`
  mutation updateBill($updateBillInput: CreateBillInput!, $id: Int!) {
    updateBill(updateBillInput: $updateBillInput, id: $id) {
      id
      billNo
      vendorId
      accountId
      billDate
      dueDate
      subTotal
      tax
      totalAmount
      balance
    }
  }
`;

export const APPROVE_OR_REJECT_BILL = gql`
  mutation markBillAsApprovedOrRejected($billId: Int!, $isApproved: Boolean!) {
    markBillAsApprovedOrRejected(isApproved: $isApproved, billId: $billId) {
      id
      billNo
      isApproved
      approvedOrRejectedBy
    }
  }
`;
